import { render, staticRenderFns } from "./heatMap.vue?vue&type=template&id=130e745e&scoped=true&"
import script from "./heatMap.vue?vue&type=script&lang=js&"
export * from "./heatMap.vue?vue&type=script&lang=js&"
import style0 from "./heatMap.vue?vue&type=style&index=0&id=130e745e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130e745e",
  null
  
)

export default component.exports